<script>
import ItineraryOverviewCreate from './ItineraryOverviewCreate';

export default {
  name: 'ItineraryOverviewList',
  components: {
    ItineraryOverviewCreate,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    productTypes: {
      type: Array,
      default: () => [],
    },
    productTypesLoading: {
      type: Boolean,
      default: false,
    },
    createLoading: {
      type: Boolean,
      default: false,
    },
    createError: {
      type: [ Boolean, String ],
      default: false,
    },
  },
  data() {
    return {
      search: '',
      showCreateModal: false,
      productTypeId: null,
      headers: [
        { text: this.$t('itinerary.overview.table.title'), align: 'left', value: 'name' },
        { text: this.$t('itinerary.overview.table.country'), align: 'left', value: 'country.alias' },
        { text: this.$t('itinerary.overview.table.domains'), align: 'left', value: 'domainsCount' },
        { text: this.$t('itinerary.overview.table.isExtension'), align: 'left', value: 'isExtension' },
        { text: this.$t('itinerary.overview.table.productType'), align: 'right', value: 'productType.name' },
      ],
      pagination: {
        rowsPerPage: 10,
        descending: false,
        sortBy: 'name',
      },
      showInactiveDomains: false,
    };
  },
  computed: {
    filteredItems: {
      get() {
        return this.items.filter(this.filtering);
      },
    },
  },
  methods: {
    filtering(item) {
      return this.product(item.productTypeId) && this.indexOf(item.name) && (this.showInactiveDomains || item.activeDomains.length > 0);
    },
    indexOf(value) {
      return !this.search || value.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
    },
    product(value) {
      return !this.productTypeId || value === this.productTypeId;
    },
    createItinerary(event) {
      this.$emit('createItinerary', event);
    },
    closeModalAndClear() {
      this.showCreateModal = false;
      this.search = '';
      this.productTypeId = null;
    },
  },
};
</script>

<template>
  <v-container
    class="ma-0 fluid"
  >
    <itinerary-overview-create
      v-if="showCreateModal"
      :name="search"
      :product-type-id="productTypeId"
      :product-types="productTypes"
      :create-loading="createLoading"
      :create-error="createError"
      @cancel="closeModalAndClear"
      @confirm="createItinerary"
    />
    <v-layout row>
      <v-flex md4>
        <v-text-field
          v-model="search"
          :loading="loading"
          :label="$t('inputs.placeholders.search')"
          class="px-4"
          clearable
          clear-icon="clear"
          append-icon="search"
        />
      </v-flex>
      <v-flex md4>
        <v-select
          v-model="productTypeId"
          :loading="productTypesLoading"
          :items="productTypes"
          label="Product type"
          item-text="name"
          item-value="id"
          clearable
          clear-icon="clear"
        />
      </v-flex>
      <v-flex shrink>
        <v-btn
          :loading="loading"
          icon
          @click="$emit('refresh')"
        >
          <v-icon>cached</v-icon>
        </v-btn>
      </v-flex>
      <v-flex md3>
        <div style="display: flex; align-items: center;">
          <label for="show-inactive" class="mr-2">
            Show inactive
          </label>
          <v-checkbox id="show-inactive" v-model="showInactiveDomains"/>
        </div>
      </v-flex>
      <v-flex md4>
        <v-btn
          :loading="loading"
          :disabled="loading"
          class="right"
          large
          color="primary"
          @click="showCreateModal = true"
        >
          {{ $t('inputs.actions.add') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex md12>
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          :pagination.sync="pagination"
          :loading="loading"
          :search="search"
          class="elevation-1"
          item-key="id"
        >
          <template v-slot:items="props">
            <tr
              class="table-row"
              @click="$router.push({
                name: 'ItineraryEditGeneral',
                params: { id: props.item.id }
              })"
            >
              <td>{{ props.item.name }}</td>
              <td>
                <v-chip
                  v-for="(country, index) in props.item.countries"
                  :key="`trip-country__${index}`"
                  color="teal"
                  text-color="white"
                  small
                >
                  {{ country.alias }}
                </v-chip>
              </td>
              <td>
                <v-chip
                  v-for="(domain, index) in props.item.activeDomains"
                  :key="`active-domain-${index}`"
                  color="teal"
                  text-color="white"
                  small
                >
                  {{ domain.shortName }}
                </v-chip>
                <v-chip
                  v-for="(domain, index) in props.item.inactiveDomains"
                  :key="`inactive-domain-${index}`"
                  color="red"
                  text-color="white"
                  small
                >
                  {{ domain.shortName }}
                </v-chip>
              </td>
              <td class="text-sm-center text-lg-center">
                <v-icon v-if="props.item.isExtension">check</v-icon>
              </td>
              <td class="text-sm-right text-lg-right">{{ props.item.productType }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
  .table-row {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryOverviewList.vue